// src/utils/isSudsPrompt.ts
export function isSudsPrompt(t?: string) {
  if (!t) return false;

  const s = t
    .toLowerCase()
    .replace(/[—–−]/g, "-")
    .replace(/\s+/g, " ")
    .trim();

  // Quick exits: educational/definition content should NOT trigger SUDS mode
  const looksLikeDefinition =
    /\b(suds stands for|subjective units of distress scale|it's a way|therapists use suds|during erp|helps you|used to help|you’ll often be asked)\b/.test(s) ||
    /\b0\s+means\b/.test(s) ||
    /\b10\s+means\b/.test(s);

  // If it looks like a definition and there is no question mark, do NOT trigger
  if (looksLikeDefinition && !s.includes("?")) return false;

  // ✅ UPDATED: allow "from 0 (not at all) to 10 (extremely anxious)"
  // supports: "0-10", "0 to 10", "from 0 to 10", with optional parentheses after 0/10
  const pScale =
    /\b(?:from\s*)?0(?:\s*\([^)]{0,80}\))?\s*(?:-|to)\s*(?:10|ten)(?:\s*\([^)]{0,80}\))?\b/;

  // Slightly broaden common phrasing helpers
  const scaleWords = /\b(?:on|using)\s+a\s+scale\b/;

  // Signals that it's asking *now* for a rating
  const promptVerbs =
    /\b(how (?:do|did|would|are|were) you (?:feel|rate)|rate (?:it|your|how)|give|enter|provide|share|pick|choose|select)\b/;

  // Temporal/imperative cues that imply an immediate rating
  const timeCues =
    /\b(before we begin|right now|now|at this moment|after that|how do you feel now)\b/;

  const sudsWords = /\b(suds|subjective units of distress)\b/;

  // Final decision:
  // (scale + prompt verbs) OR (scale + time cues) OR (suds words + prompt verbs)
  // OR (explicit "on a scale" + scale).
  if (
    (pScale.test(s) && promptVerbs.test(s)) ||
    (pScale.test(s) && timeCues.test(s)) ||
    (sudsWords.test(s) && promptVerbs.test(s)) ||
    (scaleWords.test(s) && pScale.test(s))
  ) {
    return true;
  }

  return false;
}
